import { useState, useEffect } from 'react'
import * as React from 'react';
import "./quickanalytics.scss"
import Dropdown from 'react-bootstrap/Dropdown';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { LineChart } from '@mui/x-charts/LineChart';
import { Card, CardContent, Typography } from '@mui/material';
import axios from 'axios';
import { CSVLink } from "react-csv";
import { toast } from 'react-toastify';
import Environment from 'utils/environment';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    LineElement,
    PointElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
} from 'chart.js';
ChartJS.register(LineElement, PointElement, CategoryScale, LinearScale, Tooltip, Legend);

const Quickanalytics = () => {

    const xLabels = [1, 2, 3, 4, 5, 6, 7];
    const buyersData = [10, 20, 15, 30, 25, 35, 40];
    const salesData = [5, 15, 10, 25, 20, 30, 38];

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [QuickAnalytic, setQuickAnalytic] = useState([]);
    const val = localStorage.getItem("accessToken");
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [QuickAnalyticstas, setQuickAnalyticstas] = useState([]);
    const API_URL = Environment.base_url2;
    const API_URL1 = Environment.base_url;


    const onChange = (dates) => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
    };


    const handleCancel = () => {
        setStartDate(null);
        setEndDate(null);
        setIsOpen(false);
    };

    const handleApply = () => {

        setIsOpen(false);
    };


    // Quick Analytics API 
    const QuickAnalytics = async () => {
        try {
            const response = await axios.get(`${API_URL}/users?limit=10&offset=1`, {
                headers: {
                    Authorization: "Bearer " + val,
                },
            });
            if (response.data.data.users) {
                setQuickAnalytic(response.data.data.users);
            }
        } catch (error) {
            console.error("Error fetching banners:", error);
        }
    };


    //// get for products
    const [products, setProducts] = useState([]);
    const fetchProducts = async () => {
        try {
            const response = await axios.get(`${API_URL}/store/products/top-saver?limit=10&offset=1`, {
                headers: {
                    Authorization: "Bearer " + val,
                },
            });

            if (response.data.data.products) {
                setProducts(response.data.data.products);
            }
        } catch (error) {
            console.error("Error fetching products:", error);
        }
    };

    // id base api call mehtod get 
    const [producId, setProducId] = useState([]);
    const fetchProductsId = async (id) => {
        try {
            const response = await axios.get(`${API_URL}/users/1`, {
                headers: {
                    Authorization: "Bearer " + val,
                },
            });
            if (response.data.data.products) {
                setProducId(response.data.data.products);
            }
        } catch (error) {
            console.error("Error fetching products:", error);
        }
    };



    // --- CSV and Selection Logic ---

    // Handle "Select All" checkbox change
    const handleSelectAllUsers = (e) => {
        if (e.target.checked) {
            const allUserEmails = QuickAnalytic.map(user => user.email);
            setSelectedUsers(allUserEmails);
        } else {
            setSelectedUsers([]);
        }
    };
    // Handle individual row checkbox change
    const handleUserSelect = (e, email) => {
        if (e.target.checked) {
            setSelectedUsers(prevSelected => [...prevSelected, email]);
        } else {
            setSelectedUsers(prevSelected => prevSelected.filter(selectedEmail => selectedEmail !== email));
        }
    };

    // Prepare CSV data ONLY for selected users
    const csvData = QuickAnalytic
        .filter(user => selectedUsers.includes(user.email))
        .map(user => ({
            Name: user.name || "N/A",
            Email: user.email || "N/A",
            Phone: user.contactNo || "N/A",
            Amount: user.amount || "N/A"
        }));





    /// get status
    const quantityStats = async () => {
        //    setLoader(true);
        //    setOrderStats([]);
        try {
            const response = await axios.get(
                `${API_URL1}/orders/stats`,
                {
                    headers: {
                        Authorization: "Bearer " + val,
                    },
                }
            );
            const resData = response?.data?.data;
            //  setsyncing(response.data.data.syncing?.updatedAt);
            //  setOrderStats(resData);
            setQuickAnalyticstas(resData)

            //  setLoader(false);
        } catch (error) {
            //  setLoader(false);

            console.error("Error fetching order stats:", error);
        }
    }


    useEffect(() => {

        QuickAnalytics();
        fetchProducts()
        fetchProductsId()
        quantityStats()

    }, []);

 

    
    const data = {
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
        datasets: [
            {
                label: 'Grocery',
                data: [18, 25, 5, 13, 3, 28, 10],
                borderColor: 'red',
                backgroundColor: 'transparent',
                tension: 0.5,
                fill: true,
                pointBackgroundColor: ['transparent', 'white', 'white', 'white', 'transparent', 'white'],
                pointBorderColor: 'red',
                pointRadius: [0, 6, 6, 6, 0, 6],
                pointHoverRadius: 8,
            },
            {
                label: 'Pharmacy',
                data: [10, 9, 20, 28, 10, 0],
                borderColor: 'lime',
                backgroundColor: 'transparent',
                tension: 0.5,
                fill: true,
                pointBackgroundColor: ['transparent', 'white', 'transparent', 'white', 'transparent', 'transparent'],
                pointBorderColor: 'lime',
                pointRadius: [0, 6, 0, 6, 0, 0],
                pointHoverRadius: 8,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    color: 'white',
                    boxWidth: 20,
                    boxHeight: 1,
                    padding: 20,
                    font: {
                        size: 16,
                    },
                },
            },
            tooltip: {
                enabled: true,
                backgroundColor: '#333',
                titleColor: '#fff',
                bodyColor: '#fff',
            },
        },

        scales: {
            x: {
                ticks: {
                    display: false,
                },
                grid: {
                    color: '#777',
                    drawOnChartArea: false,
                },
            },
            y: {
                min: 0,
                max: 30,
                ticks: {
                    step: '5',
                    color: 'white',
                },
                grid: {
                    color: '#777',
                },
            },
        },
    };

    return (
        <div className="content">
            <section className='analytics'>



                <div className='uppermainhead'>
                    <h2 className='quickheading'>Quick <span>Analytics</span></h2>
                    <div className='threebuttons'>
                        <span className='inner'>07 Days</span>
                        <span className='inner'>28 Days</span>
                        <span className={`calendarpsan ${isOpen ? "active" : ""}`}
                            onClick={() => setIsOpen(!isOpen)}>
                            custom
                        </span>
                        {isOpen && (
                            <div className="datepicker-dropdown">
                                <DatePicker
                                    selected={startDate}
                                    onChange={onChange}
                                    startDate={startDate}
                                    endDate={endDate}
                                    selectsRange
                                    inline
                                />

                            </div>
                        )}
                    </div>
                </div>


                <div className="ordercardsparent">
                    <div className='innercardmain'>
                        <h6 className='bluetext'>Order Received</h6>
                        <h2 className='whitetext'>127</h2>
                        <div className='parenttextcard'>
                            <p>Since last month</p>
                            <h6 className='red'>-5.25%</h6>
                        </div>
                    </div>
                    <div className='innercardmain'>
                        <h6 className='bluetext'>
                            Order Pending</h6>
                        <h2 className='whitetext'>
                            {/* 05 */}

                            {QuickAnalyticstas?.pendingOrder}

                        </h2>
                        <div className='parenttextcard'>
                            <p>Since last month</p>
                            <h6 className='red'>-5.25%</h6>
                        </div>
                    </div>
                    <div className='innercardmain'>
                        <h6 className='bluetext'>Order Delivered</h6>
                        <h2 className='whitetext'>
                            {/* 122 */}
                            {QuickAnalyticstas?.deliveredOrder}



                        </h2>
                        <div className='parenttextcard'>
                            <p>Since last month</p>
                            <h6 className='red'>-5.25%</h6>
                        </div>
                    </div>
                </div>
                <div className='reveneueparent'>
                    <div className='left'>
                        <div className='parentsfourcard'>
                            <div className='firstcard'>
                                <h6 className='bluetext'>New Users Register</h6>
                                <h2 className='whitetext'>127</h2>
                                <div className='parenttextcard'>
                                    <p>Since last month</p>
                                    <h6 className='red'>-5.25%</h6>
                                </div>
                            </div>
                            <div className='firstcard'>
                                <h6 className='bluetext'>Total Orders</h6>
                                <h2 className='whitetext'>
                                    {/* 127 */}
                                    {QuickAnalyticstas?.totalOrder}


                                </h2>
                                <div className='parenttextcard'>
                                    <p>Since last month</p>
                                    <h6 className='red'><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                        <path d="M9.80454 3.5H5.79972H2.19346C1.57635 3.5 1.26779 4.25891 1.70492 4.70379L5.03476 8.09274C5.56831 8.63575 6.43612 8.63575 6.96967 8.09274L8.23604 6.80389L10.2995 4.70379C10.7302 4.25891 10.4217 3.5 9.80454 3.5Z" fill="#FF5555" />
                                    </svg>-5.25%</h6>
                                </div>
                            </div>
                            <div className='firstcard'>
                                <h6 className='bluetext'>Total Revenue</h6>
                                <h2 className='whitetext'>127</h2>
                                <div className='parenttextcard'>
                                    <p>Since last month</p>
                                    <h6 className='green'><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                        <path d="M9.80454 8.5H5.79972H2.19346C1.57635 8.5 1.26779 7.74109 1.70492 7.29621L5.03476 3.90726C5.56831 3.36425 6.43612 3.36425 6.96967 3.90726L8.23604 5.19611L10.2995 7.29621C10.7302 7.74109 10.4217 8.5 9.80454 8.5Z" fill="#2BEF2B" />
                                    </svg>-5.25%</h6>
                                </div>
                            </div>
                            <div className='firstcard'>
                                <h6 className='bluetext'>Growth</h6>
                                <h2 className='whitetext'>127</h2>
                                <div className='parenttextcard'>
                                    <p>Since last month</p>
                                    <h6 className='red'><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                        <path d="M9.80454 3.5H5.79972H2.19346C1.57635 3.5 1.26779 4.25891 1.70492 4.70379L5.03476 8.09274C5.56831 8.63575 6.43612 8.63575 6.96967 8.09274L8.23604 6.80389L10.2995 4.70379C10.7302 4.25891 10.4217 3.5 9.80454 3.5Z" fill="#FF5555" />
                                    </svg>-5.25%</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='right'>
                        <div className='revenuemainbox'>
                            <div className='upperboxparent'>
                                <div className='textmain'>
                                    <h2 className='reventext'>Reveneue</h2>
                                    <p>Last 30 Days</p>
                                </div>
                                <div className='maindrop'>
                                    <Dropdown>
                                        <Dropdown.Toggle id="dropdown-basic">
                                            <div className='mainimg'>
                                                <img src='\assestsss\dotiocnss.svg' alt='img' className='img-fluid icon' />
                                            </div>
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                            <Dropdown.Item href="#/action-1"> <div className="checkboxmain">
                                                <label class="checkbox" for="yellow">
                                                    <input type="checkbox" name="color" value="yellow" id="yellow" />
                                                    <span class="checkmark"></span>
                                                </label>
                                                <p className="checkboxpara">Revenue</p>
                                            </div></Dropdown.Item>

                                            <Dropdown.Item href="#/action-2">
                                                <div className="checkboxmain">
                                                    <label class="checkbox" for="yellow1">
                                                        <input type="checkbox" name="color" value="yellow" id="yellow1" />
                                                        <span class="checkmark"></span>
                                                    </label>
                                                    <p className="checkboxpara">Orders</p>
                                                </div></Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </div>
                            <div style={{}}>
                                <Line data={data} options={options} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='userparent'>
                    <div className='leftuser'>
                        {/* //// API ALL */}
                        <div className='userbox'>
                            <div className='uppermain'>
                                <h3 className='bluemain'>Top Users</h3>

                                <CSVLink
                                    data={csvData}
                                    filename={"top_users_selected.csv"}
                                    className='paramain'
                                    onClick={(event) => {
                                        if (selectedUsers.length === 0) {
                                            event.preventDefault();
                                            toast.error("Please select users to export.");
                                        }
                                    }}
                                >
                                    <img src='\assestsss\shareicon.svg' alt='img' className='img-fluid' />
                                    Export CSV

                                    ({selectedUsers.length})
                                </CSVLink>
                            </div>
                            <div className='main-card'>
                                <div className='table-responsive'>
                                    <table className='table borderless-table'>
                                        <thead className='tblheadss'>
                                            <tr>
                                                <th><div className="checkboxmain">
                                                    <label className="checkbox" htmlFor="selectAllUsers">
                                                        {/* <input type="checkbox" name="color" value="yellow" id="yellow3" /> */}
                                                        <input
                                                            type="checkbox"
                                                            id="selectAllUsers"
                                                            onChange={handleSelectAllUsers}
                                                            checked={QuickAnalytic.length > 0 && selectedUsers.length === QuickAnalytic.length}
                                                        />
                                                        <span class="checkmark"></span>
                                                    </label>

                                                </div></th>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Phone </th>
                                                <th>Amount</th>
                                            </tr>
                                        </thead>
                                        {QuickAnalytic.map((user, index) => (
                                            <tbody>
                                                <tr className={index % 2 === 0 ? 'active' : ''} key={user.email || index}>
                                                    <td >
                                                        <div className="checkboxmain">
                                                            <label class="checkbox" htmlFor={`user-checkbox-${index}`}>
                                                                {/* <input type="checkbox" name="color" value="yellow" id={`yellow4-${index}`} /> */}
                                                                <input
                                                                    type="checkbox"
                                                                    id={`user-checkbox-${index}`}
                                                                    checked={selectedUsers.includes(user.email)}
                                                                    onChange={(e) => handleUserSelect(e, user.email)}
                                                                />
                                                                <span class="checkmark"></span>
                                                            </label>

                                                        </div>
                                                    </td>
                                                    <td>
                                                        {user.name ? user.name : "N/A"}
                                                    </td>
                                                    <td>
                                                        {user.email ? user.email : "N/A"}
                                                    </td>
                                                    <td>
                                                        {user.contactNo ? user.contactNo : "N/A"}
                                                        {/* {user.contactNo} */}
                                                    </td>

                                                    <td>
                                                        {user.amount ? user.amount : "N/A"}
                                                    </td>
                                                </tr>



                                            </tbody>
                                        ))}
                                    </table>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className='rightuser'>
                        <div className='userbox'>
                            <div className='uppermain'>
                                <h3 className='bluemain'>Top Products</h3>
                                <p className='paramain'><img src='\assestsss\shareicon.svg' alt='img' className='img-fluid' />Export CSV</p>
                            </div>
                            <div className='main-card'>
                                <div className='table-responsive'>
                                    <table className='table'>
                                        <thead className='tblheadss'>
                                            <tr>
                                                <th>
                                                    {/* <div className="checkboxmain">
                                                    <label class="checkbox" for="yellow3">
                                                        <input type="checkbox" name="color" value="yellow" id="yellow3" />
                                                        <span class="checkmark"></span>
                                                    </label>

                                                </div> */}
                                                    <div className="checkboxmain">
                                                        <label className="checkbox" htmlFor="selectAllProducts">
                                                            <input type="checkbox" id="selectAllProducts" />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </div>
                                                </th>
                                                <th>Products</th>
                                                <th>Category</th>
                                                <th>Price </th>

                                            </tr>
                                        </thead>
                                        {!products.length === 0 ? (
                                            <>
                                                {products.map((product, index) => (
                                                    <tbody>
                                                        <tr className={index % 2 === 0 ? 'active' : ''} key={product.id || index}>
                                                            <td >
                                                                <div className="checkboxmain">
                                                                    <label class="checkbox" htmlFor={`product-checkbox-${index}`}>
                                                                        <input type="checkbox" name="color" id={`product-checkbox-${index}`} />
                                                                        <span class="checkmark"></span>
                                                                    </label>

                                                                </div>
                                                            </td>
                                                            <td>{product.productName || "Not Available"}</td>
                                                            <td>{product.category || "Not Available"}</td>
                                                            <td>Rs {product.price || "N/A"}</td>
                                                        </tr>

                                                    </tbody>
                                                ))}
                                            </>
                                        ) : (
                                            <tbody>
                                                <tr>
                                                    <td colSpan="4" className="text-center">No Products Available</td>
                                                </tr>
                                            </tbody>
                                        )}


                                    </table>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Quickanalytics